import { useSuspenseQuery } from '@apollo/client';
import { HomePage, QUERY_CURRENT_QUOTE, QuoteQuery, QuoteQueryVariables } from '@edwin-group/cj-graphql';

export const DailyCardQuote = ({ page }: { page: HomePage | null }) => {
  const date = new Date().toISOString().split('T')[0];

  const { data: quote } = useSuspenseQuery<QuoteQuery, QuoteQueryVariables>(QUERY_CURRENT_QUOTE, {
    variables: {
      date: {
        eq: date,
      },
    },
    fetchPolicy: 'cache-and-network',
  });

  if (!quote?.quotes?.data?.[0]?.attributes.quote) return null;

  return (
    <div className="flex h-full flex-col items-center gap-sh-15 rounded-2xl bg-[#4B7EEA] p-5 text-center">
      <h2 className=" text-center font-aTypeStencil text-sh-24-22 text-[#EFC1D2]">
        {page?.cardsSection?.dailyInspirationTitle}
      </h2>
      <p className="font-cadiz text-sh-xxs text-white">{quote?.quotes?.data?.[0]?.attributes.quote}</p>
      <div>
        {quote?.quotes?.data?.[0]?.attributes?.author && (
          <p className="font-cadiz text-sh-xxs font-bold text-white">{quote?.quotes?.data?.[0]?.attributes.author}</p>
        )}
        {quote?.quotes?.data?.[0]?.attributes?.occupation && (
          <p className="font-cadiz text-sh-xxxs font-bold text-white">
            {quote?.quotes?.data?.[0]?.attributes.occupation}
          </p>
        )}
      </div>
    </div>
  );
};
